import gql from 'graphql-tag'
import SCREENING_RULE from '../fragments/screeningRule'

/**
 * Whole-list replace: a rule has no id, so its index in `rules` is its whole identity.
 *
 * Raw `gql` and the IR-notification directive follow the other audience mutations — see the note in
 * mutations/criterionOptionV2.ts.
 */
export const SET_SCREENING_RULES_V2 = gql`
  mutation setScreeningRulesV2($input: SetScreeningRulesV2Input!) {
    recordAudienceChangedForIRSNotification @client(always: true)
    setScreeningRulesV2(input: $input) {
      surveyId
      screeningRules {
        ...ScreeningRule
      }
    }
  }
  ${SCREENING_RULE}
`
